<template lang="pug">
  .container
    .columns
      .column.is-3
        .field
          label.label Número de PG
          .control
            input.input.is-primary(
              type='text', 
              v-model="pg"
            )
      .column.is-3
        .field
          label.label Capacidad (Litros)
          .control
            input.input.is-primary(
              type='text', 
              v-model="capacidad"
            )
      .column.is-3
        .field
          label.label Placa
          .control
            input.input.is-primary(
              type='text', 
              v-model="placa"
            )
      .column.is-3
        .field
          label.label ID CRE
          .control
            input.input.is-primary(
              type='text', 
              v-model="idCRE"
            )
    .columns
      .column.is-4
        .field
          label.label Transportista
          TypeaheadPorteador(:options="porteadores" :optionSelect="itemDataPort" v-model="itemSelPort" :isDisabled="isTH_disabled")
      .column.is-4
        .field
          label.label Comercializadora
            .control.has-icons-left
              .select.is-primary.is-rounded
                select(v-model="comercializadora")
                  option(value="" checked) Seleccione una Comercializadora
                  option(v-for="comer in comercializadoras" :key="comer.id" :value="comer.nombre") {{ comer.nombre }}
              .icon.is-small.is-left
                i.fas.fa-tag
      .column.is-4
        .field
          label.label Grupo
            .control.has-icons-left
              .select.is-primary.is-rounded
                select(v-model="grupo")
                  option(value="" checked) Seleccione un Grupo
                  option(v-for="gr in grupos" :key="gr.id" :value="gr.id") {{ gr.nombre }}
              .icon.is-small.is-left
                i.fas.fa-tag
    .columns
      .column.is-4
        span(v-html="dataPorteadorSelect()")
    .columns
      .column.is-6
        button.button.is-info(@click="saveAutotanque")
          | Guardar
        | &nbsp
        button.button.is-default(@click="cancelForm")
          | Cancelar
</template>

<script>
  import TypeaheadPorteador from '@/components/sca_Componentes/acceso/shared/TypeaheadPorteador.vue'
  import autotanquesServicesIRGE from '@/services//irge/autotanquesIRGE.js'
  import moment from 'moment'

  export default {
    name: 'NewAutotanque',
    components: { TypeaheadPorteador },
    data() {
      return {
        pg: '',
        capacidad: 0,
        placa: '',
        idCRE: '',
        grupo: '',
        porteadores: [],
        itemDataPort: {},
        itemSelPort: {},
        comercializadoras: [
          { id: 1, nombre: 'PROPANGOL'},
          { id: 2, nombre: 'MOVENERGY'}
        ],
        comercializadora: '',
        isTH_disabled: false,
        grupos: [
          { id:"NIETO", nombre:"Nieto" },
          { id:"MABARAK", nombre:"Mabarak" },
          { id:"URIBE", nombre:"Uribe" },
          { id:"METROPOLITANO", nombre:"Metropolitano" },
          { id:"FLENSA", nombre:"Flensa" },
          { id:"TOMZA", nombre:"Tomza" }
        ]
      }
    },
    methods: {
      iniciarComponente () {
        console.log('Iniciar componente')
        this.obtenerPorteadores()
      },
      saveAutotanque() {
        let id = 0
        autotanquesServicesIRGE.getIdTanque()
          .then( resp => {
            id = resp[0].id
            let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
            
            autotanquesServicesIRGE.guardarTanque(id, this.pg, this.comercializadora, this.itemSelPort.nombre, this.grupo, this.capacidad, this.placa, fechaReg, this.idCRE)
              .then( r => {
                console.log(r)
                if (r.success) {
                  let toast = this.$toasted.show(`El autotanque ha sido registrado.`, { 
                    theme: "toasted-primary", 
                    position: "bottom-right", 
                    duration : 3000,
                    iconPack: 'fontawesome',
                    icon: 'check',
                    action : {
                      text : 'Ok',
                      onClick : (e, toastObject) => {
                        toastObject.goAway(0)
                      }
                    },
                  })
                  this.$emit('closeForm', 'save')
                } else {
                  let toast = this.$toasted.show(`Error: ${r.respuesta}.`, { 
                    theme: "toasted-primary", 
                    position: "bottom-right", 
                    duration : 3000,
                    iconPack: 'fontawesome',
                    icon: 'done',
                    action : {
                      text : 'Ok',
                      onClick : (e, toastObject) => {
                        toastObject.goAway(0)
                      }
                    },
                  })
                }
              })
              .catch( error => console.log(error))
            
          })
          .catch( e => console.log(e))
      },
      cancelForm () {
        this.pg = '',
        this.capacidad = 0,
        this.placa = '',
        this.idCRE = '',
        this.grupo = '',
        this.comercializadora = ''
        this.itemSelPort = {}
        this.itemDataPort = {}
        this.$emit('closeForm', 'cancel')
      },
      obtenerPorteadores () {
        console.log('Obtener Porteadores')
        autotanquesServicesIRGE.getPorteadores()
          .then(resPort => {
            console.log(resPort)
            this.porteadores = resPort
          })
      },
      dataPorteadorSelect () {
        let texto = ''
        if (Object.keys(this.itemSelPort).length > 0 ){
          texto = `<div class="card">
            <div class="card-content">
              <p class="title is-size-6">
                <b>Porteador:</b> ${this.itemSelPort.nombre}<br />
              </p>
              <p class="subtitle is-size-7">
                <b>Clave:<b /> ${this.itemSelPort.clave}<br />
                <b>Grupo:<b /> ${this.itemSelPort.grupo}<br />
                <b>RFC:<b /> ${this.itemSelPort.rfc}<br />
              </p>
            </div>
          </div>`
        }
        return texto
      }
    },
    created () {
      this.iniciarComponente()
    },

  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/acceso/NewAutotanque.vue